import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home/Index'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/product',
      component:resolve =>{
        require(['../views/Product'],resolve)
      }
    },
    {
      path: '/register',
      component:resolve =>{
        require(['../views/Register'],resolve)
      }
    },
    {
      path: '/course',
      component:resolve =>{
        require(['../views/Course'],resolve)
      }
    },
    {
      path: '/detail/:detailType/:detailID',
      component:resolve =>{
        require(['../views/Detail'],resolve)
      }
    },
    {
      path: '/dynamic',
      component:resolve =>{
        require(['../views/Dynamic'],resolve)
      }
    },
    {
      path:"*",
      redirect:'/'
    }

  ]
})
